(function () {
  // Gift-card add. Separate from rolly_addToCartAndOpen because this path goes
  // straight to /checkout rather than opening the drawer, but it must still emit
  // the standard cart events — otherwise this mutation is invisible to pixels,
  // apps and shopping agents, which is the whole point of dispatching them on
  // the other two paths. Helpers are globals from rolly-cart.js, which
  // theme.liquid loads first; guarded so a load-order change cannot break adds.
  async function addToCart(variantId, qty, triggerEl) {
    var quantity = qty || 1;
    var target = (triggerEl && triggerEl.isConnected) ? triggerEl : document;
    var linesUpdate = typeof window.rolly_createCartLinesUpdateEvent === 'function'
      ? window.rolly_createCartLinesUpdateEvent(target, variantId, quantity)
      : null;
    var settled = false;

    try {
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      });
      if (!response.ok) {
        var errBody = await response.json().catch(function () { return {}; });
        throw new Error(errBody.description || errBody.message || 'Cart add failed (' + response.status + ')');
      }
      settled = true;
      if (typeof window.rolly_resolveCartLinesUpdate === 'function') {
        window.rolly_resolveCartLinesUpdate(linesUpdate);
      }
      return response;
    } catch (err) {
      if (!settled) {
        if (typeof window.rolly_dispatchCartErrorEvent === 'function') {
          window.rolly_dispatchCartErrorEvent(target, String((err && err.message) || err), 'SERVICE_UNAVAILABLE');
        }
        if (linesUpdate) linesUpdate.reject(err);
      }
      throw err;
    }
  }

  // GALLERY: thumb -> stage sync + stage scroll -> active thumb
  var gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    var track  = gallery.querySelector('[data-gallery-track]');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-thumb]'));
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-slide]'));
    var plate  = gallery.querySelector('[data-plate]');
    function setActive(i) {
      thumbs.forEach(function (t) { t.classList.toggle('is-active', +t.dataset.thumb === i); });
      if (plate && slides[i]) plate.textContent = slides[i].getAttribute('data-caption') || '';
    }
    // Lock the scroll-driven active sync while a programmatic (thumb-click) smooth
    // scroll is in flight, so intermediate scrollLeft values don't flip the active
    // thumb back and forth (the visible "flicker"). Released on scrollend, with a
    // timeout fallback for browsers without scrollend (older Safari) and for the
    // no-op case where clicking the current thumb produces no scroll event.
    var programmatic = false;
    var programmaticTimer;
    function beginProgrammatic() {
      programmatic = true;
      clearTimeout(programmaticTimer);
      programmaticTimer = setTimeout(function () { programmatic = false; }, 600);
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = +t.dataset.thumb;
        var s = slides[i];
        setActive(i);
        beginProgrammatic();
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (s && track) track.scrollTo({ left: s.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      });
    });

    // REVERSIBLE BADGE: flips between the front (first slide) and the reverse
    // side (always the last slide). A pill is rendered on every slide, so
    // always-jump-to-last is a no-op once the viewer is already on the last
    // slide — a dead click, which is what Clarity recorded here. Toggling
    // guarantees the badge always produces visible movement.
    // The pill lives inside the slide being viewed, so that slide is the
    // current index; this needs no thumbs, which are absent for single-media
    // products. Scoped to this gallery instance only.
    function flipReversible(pill) {
      var last = slides.length - 1;
      if (last < 1) return;
      var from = pill.closest('[data-slide]');
      var i = (from && +from.getAttribute('data-slide') === last) ? 0 : last;
      var s = slides[i];
      if (!s) return;
      setActive(i);
      beginProgrammatic();
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (track) track.scrollTo({ left: s.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    }
    gallery.addEventListener('click', function (e) {
      var pill = e.target.closest('[data-reversible-jump]');
      if (!pill) return;
      flipReversible(pill);
    });
    gallery.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var pill = e.target.closest('[data-reversible-jump]');
      if (!pill) return;
      e.preventDefault();
      flipReversible(pill);
    });

    // INLINE VIDEO: autoplay (muted) only while the slide is in view; pause off-screen.
    // Honours prefers-reduced-motion by leaving the poster frame in place.
    var videos = Array.prototype.slice.call(gallery.querySelectorAll('.pdp-gallery__video'));
    if (videos.length) {
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      // Force silence regardless of whether the source has an audio track. The
      // muted attribute alone is unreliable for autoplay; the JS property is not.
      videos.forEach(function (v) { v.muted = true; v.defaultMuted = true; });
      function safePlay(v) {
        v.muted = true;
        var p = v.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      }
      if (reduceMotion) {
        videos.forEach(function (v) { v.removeAttribute('autoplay'); v.pause(); });
      } else if ('IntersectionObserver' in window) {
        // Stop native autoplay firing for off-screen videos before the observer runs.
        videos.forEach(function (v) { v.removeAttribute('autoplay'); v.pause(); });
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            entry.target._inView = entry.isIntersecting;
            // Don't resume while the lightbox is open — it owns playback then.
            if (entry.isIntersecting && !document.body.classList.contains('rl-lightbox-active')) {
              safePlay(entry.target);
            } else if (!entry.isIntersecting) {
              entry.target.pause();
            }
          });
        }, { threshold: 0.6 });
        videos.forEach(function (v) { io.observe(v); });
      }

      // Lightbox owns playback while open: pause the inline (background) video on
      // open, and resume on close only if its slide is the one currently in view.
      document.addEventListener('rolly:lightbox-open', function () {
        videos.forEach(function (v) { v.pause(); });
      });
      document.addEventListener('rolly:lightbox-close', function () {
        if (reduceMotion) return;
        videos.forEach(function (v) { if (v._inView) safePlay(v); });
      });
    }

    if (track) {
      var raf;
      track.addEventListener('scroll', function () {
        if (programmatic) return;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          setActive(i);
          var at = thumbs[i];
          if (at && at.scrollIntoViewIfNeeded) at.scrollIntoViewIfNeeded();
        });
      });
      track.addEventListener('scrollend', function () {
        programmatic = false;
        clearTimeout(programmaticTimer);
      });
    }
  }

  // BUY ROLLY -> add then open cart drawer (same path as quick-add)
  document.addEventListener('click', function (e) {
    var buy = e.target.closest('[data-buy]');
    if (!buy) return;
    e.preventDefault();
    quickAdd(buy);
  });

  // QUICK-ADD (gallery overlay) -> add then open the theme cart drawer + update count
  function flashState(btn, cls) {
    var orig = btn.innerHTML;
    var icon = cls === 'is-added'
      ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12l4 4l10-10"/></svg>'
      : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    btn.classList.add(cls);
    btn.innerHTML = icon;
    clearTimeout(btn._t);
    btn._t = setTimeout(function () { btn.classList.remove(cls); btn.innerHTML = orig; }, 1400);
  }

  // The slide currently shown in the gallery, and an image URL for it (a video's poster).
  function activeSlideImage() {
    var g = document.querySelector('[data-gallery]');
    if (!g) return null;
    var t = g.querySelector('[data-gallery-track]');
    var all = g.querySelectorAll('[data-slide]');
    var i = t && t.clientWidth ? Math.round(t.scrollLeft / t.clientWidth) : 0;
    var slide = all[i] || all[0];
    if (!slide) return null;
    var img = slide.querySelector('img');
    var src = (img && (img.currentSrc || img.src)) || slide.getAttribute('data-poster');
    return src ? { el: slide, src: src } : null;
  }

  // Add-to-bag micro-animation (#92, rolly-add-to-bag.js) runs alongside the add;
  // the drawer opens once both are done.
  function flyToBag(trigger) {
    var shot = activeSlideImage();
    if (!shot || typeof window.rolly_flyToBag !== 'function') return null;
    return window.rolly_flyToBag(shot.src, shot.el, trigger);
  }

  function quickAdd(qa) {
    window.rolly_addToCartAndOpen(qa.dataset.variant, 1, qa, { beforeOpen: flyToBag(qa) })
      .catch(function (err) {
        console.error('[rolly-pdp] quick-add failed:', err);
        flashState(qa, 'is-error');
      });
  }

  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-quickadd]');
    if (!qa) return;
    e.preventDefault();
    quickAdd(qa);
  });

  // GIFT CARD: amount -> swap card value + buy variant
  var amts = document.querySelector('[data-gc-amts]');
  if (amts) {
    var valEl = document.querySelector('[data-gc-value]');
    var buyEl = document.querySelector('[data-gc-buy]');
    amts.addEventListener('click', function (e) {
      var b = e.target.closest('.gc-amt');
      if (!b) return;
      amts.querySelectorAll('.gc-amt').forEach(function (x) { x.classList.remove('on'); });
      b.classList.add('on');
      if (valEl) valEl.textContent = b.dataset.price;
      if (buyEl) buyEl.dataset.variant = b.dataset.variant;
    });
    if (buyEl) buyEl.addEventListener('click', function (e) {
      e.preventDefault();
      buyEl.disabled = true;
      addToCart(buyEl.dataset.variant, 1, buyEl)
        .then(function () { window.location.href = '/checkout'; })
        .catch(function (err) {
          console.error('[rolly-pdp] gift-card add failed:', err);
          buyEl.disabled = false;
        });
    });
  }
})();
